var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"yj-button",class:[
      _vm.type ? 'yj-button--' + _vm.type : '',
      _vm.buttonSize ? 'yj-button--' + _vm.buttonSize : '',
      {
        'is-disabled': _vm.buttonDisabled,
        'is-loading': _vm.loading,
        'is-plain': _vm.plain,
        'is-round': _vm.round,
        'is-circle': _vm.circle
      }
    ],attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"type":"button"},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"yj-icon-loading"}):_vm._e(),_vm._v(" "),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/button/src/button.vue